import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const triggerChipDefaultVariants = {
  "type": "rounded",
  "highlight": "on",
  "selected": false
}
const triggerChipCompoundVariants = [
  {
    "highlight": "on",
    "selected": true,
    "css": {
      "container": {
        "bgColor": "background.default.level-3",
        "color": "content.default.level-4",
        "_hover": {
          "bgColor": "background.interaction.hover",
          "color": "content.default.level-3"
        },
        "_disabled": {
          "bgColor": "background.interaction.disabled",
          "color": "content.interaction.disabled"
        }
      }
    }
  }
]

const triggerChipSlotNames = [
  [
    "container",
    "trigger-chip__container"
  ],
  [
    "icon",
    "trigger-chip__icon"
  ],
  [
    "label",
    "trigger-chip__label"
  ],
  [
    "chevron",
    "trigger-chip__chevron"
  ]
]
const triggerChipSlotFns = /* @__PURE__ */ triggerChipSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, triggerChipDefaultVariants, getSlotCompoundVariant(triggerChipCompoundVariants, slotName))])

const triggerChipFn = memo((props = {}) => {
  return Object.fromEntries(triggerChipSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const triggerChipVariantKeys = [
  "type",
  "highlight",
  "selected"
]
const getVariantProps = (variants) => ({ ...triggerChipDefaultVariants, ...compact(variants) })

export const triggerChip = /* @__PURE__ */ Object.assign(triggerChipFn, {
  __recipe__: false,
  __name__: 'triggerChip',
  raw: (props) => props,
  variantKeys: triggerChipVariantKeys,
  variantMap: {
  "type": [
    "rounded",
    "square"
  ],
  "highlight": [
    "on",
    "off"
  ],
  "selected": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, triggerChipVariantKeys)
  },
  getVariantProps
})